import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBan = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 4,
			fill: "currentColor",
			fillOpacity: .18
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 3,
			y: 3,
			width: 14,
			height: 14,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 3.5,
				y: 3.5,
				width: 13,
				height: 13,
				rx: 6.5,
				fill: "#fff"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 3.5,
					y: 3.5,
					width: 13,
					height: 13,
					rx: 6.5,
					fill: "currentColor",
					fillOpacity: .3
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 4.5,
					y: 4.5,
					width: 11,
					height: 11,
					rx: 5.5,
					stroke: "currentColor",
					strokeOpacity: .3,
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5 5L15 15",
					stroke: "currentColor",
					strokeWidth: 2
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgBan);
export { ForwardRef as ReactComponent };
